export default class Component {

    public static initSelector: string;

    public element: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;

        document.addEventListener('destroy', this.handleDestroy);
    }

    public static is(value: unknown): value is typeof Component {
        return Object.getPrototypeOf(value) === Component;
    }

    public static create<T extends typeof Component>(element: HTMLElement): InstanceType<T> {
        const instance: Component = new this(element);

        return instance as InstanceType<T>;
    }

    public static enhance(): void {
        if (this.initSelector) {
            const type: string = Component.getDataName(this.initSelector);

            document.addEventListener('enhance', (event: CustomEvent<null | string>): void => {
                if ((event.target instanceof Element || event.target instanceof HTMLDocument) && (!event.detail || event.detail === type)) {
                    event.target.querySelectorAll(this.initSelector).forEach((element: HTMLElement): void => {
                        this.create(element);
                    });
                }
            });
        } else {
            console.warn(`[Warning] ${this.name} is missing static initSelector.`);
        }
    }

    public static getDataName(initSelector: string): string {
        return initSelector.replace(/\./g, '').replace(/^([A-Z])|[\s-_](\w)/g, (match: string, p1: string, p2: string): string => {
            if (p2) {
                return p2.toUpperCase();
            } else {
                return p1.toLowerCase();
            }
        });
    }

    destroy(): void {
        return;
    }

    handleDestroy: (event: CustomEvent<HTMLElement>) => void = (event: CustomEvent<HTMLElement>): void => {
        // trigger destroy when event target contains current element
        // and also when element is not in DOM

        if (event.detail.contains(this.element[0]) || !document.body.contains(this.element[0])) {
            this.destroy();

            document.removeEventListener('destroy', this.handleDestroy);
        }
    };
}
